import * as React from 'react';
import { useSelector } from 'react-redux';
import { ArticleHeading1, RadioButtonGroup } from '@cian/ui-kit';
import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import { ProjectsOnMap as ProjectsOnMapComponent } from '../../components/ProjectsOnMap';
import { checkOffices } from '../../selectors';
import { Map } from '../Map';
import { getViewModeOptions } from './helpers';
import { trackMapFilterClick, trackShowProjectsMap } from './tracking';

export type TViewMode = 'newBuildings' | 'offices';

export function ProjectsOnMap() {
  const hasOffices = useSelector(checkOffices);
  const [mode, setMode] = React.useState<TViewMode>('newBuildings');
  const viewModeOptions = getViewModeOptions(hasOffices);

  const onViewModeChange = React.useCallback((event: React.ChangeEvent<HTMLInputElement>, newMode: TViewMode) => {
    trackMapFilterClick(newMode);
    setMode(newMode);
  }, []);

  return (
    <ActionAfterViewed callback={trackShowProjectsMap}>
      <ProjectsOnMapComponent
        title={<ArticleHeading1>Объекты на карте</ArticleHeading1>}
        viewModeSwitch={<RadioButtonGroup options={viewModeOptions} value={mode} onChange={onViewModeChange} />}
        map={<Map mode={mode} />}
      />
    </ActionAfterViewed>
  );
}
